// config/config.js

// 필수 환경 변수 검증
const requiredEnvVars = ['REACT_APP_API_URL'];

requiredEnvVars.forEach(varName => {
  if (!process.env[varName]) {
    throw new Error(`Required environment variable "${varName}" is missing`);
  }
});

// 설정 객체
const config = {
  development: {
    API_URL: process.env.REACT_APP_API_URL || 'http://localhost:3000',
    environment: 'development'
  },
  production: {
    API_URL: process.env.REACT_APP_API_URL,
    environment: 'production'
  }
};

const env = process.env.NODE_ENV || 'development';
export default config[env];